import styled from "@emotion/styled";

import {
    breakpoints,
    colors,
    fontSizes,
    fontWeights,
    mediaQuery,
    votColorVariables,
} from "@gumtree/ui-library/src/base/theme";

import { TopSearchesContent } from "./top-search-style";

export const ModernTopSearchesContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: 8px;
    box-sizing: border-box;
    width: 100%;
    padding: 16px;
    background: ${colors.white};

    h2 {
        margin: 0;
        color: #0c132d;
        font-size: ${fontSizes.xlarge};
        font-weight: ${fontWeights.bolder};
        line-height: 28px;
    }

    h4 {
        margin: 0;
        color: #56575c;
        font-size: ${fontSizes.base};
        font-weight: ${fontWeights.normal};
        line-height: 24px;
    }

    ${TopSearchesContent} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px 12px;
    }

    ul {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    li {
        margin: 0;
    }

    .link {
        padding: 0;
        color: #56575c;
        font-size: ${fontSizes.base};
        font-weight: ${fontWeights.normal};
        line-height: 24px;
    }
`;

export const VotTopSearchesContainer = styled.section`
    box-sizing: border-box;
    width: 100%;

    ${TopSearchesContent} {
        align-items: center;
        display: grid;
        gap: 8px 12px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    ${TopSearchesContent} .section {
        display: contents;
        margin: 0;

        h4 {
            display: none;
        }

        ul {
            display: contents;
            list-style: none;
            margin: 0;
            padding: 0;
        }

        li {
            min-width: 0;
        }
    }

    .link-list {
        align-items: center;
        display: grid;
        gap: 8px 12px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .link-list .item {
        display: block;
        margin: 0;
        min-width: 0;

        &:after {
            display: none;
        }
    }

    .link {
        color: ${votColorVariables.textPrimary};
        display: block;
        font-size: 14px;
        font-weight: ${fontWeights.normal};
        line-height: 22px;
        padding: 0;
        text-align: left;
        white-space: normal;
    }

    ${mediaQuery.from(breakpoints.medium)} {
        ${TopSearchesContent},
        .link-list {
            gap: 8px 24px;
            grid-template-columns: repeat(5, minmax(0, 1fr));
        }

        .link {
            font-size: var(--vip-vot-browse-links-font-size);
            line-height: var(--vip-vot-browse-links-line-height);
            white-space: nowrap;

            &:hover {
                color: ${votColorVariables.textSecondary};
            }
        }
    }
`;
